module.exports = __webpack_public_path__ + "img/footer.a23c8ec6.svg";